import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Document_vente, Ligne_Document_Vente, Reglement } from '../models/models';
import api from './api';

export interface PosSalePayload {
  document:  Document_vente;
  lignes:    Ligne_Document_Vente[];
  reglement: Reglement;
}

export interface PosSaleResult {
  document:  Document_vente;
  lignes:    Ligne_Document_Vente[];
  reglement: Reglement;
}

interface PosState {
  loading:        boolean;
  error:          string | null;
  successMessage: string | null;
  lastSale:       PosSaleResult | null;
}

const initialState: PosState = {
  loading:        false,
  error:          null,
  successMessage: null,
  lastSale:       null,
};

export const createPosSale = createAsyncThunk<
  PosSaleResult,
  PosSalePayload,
  { rejectValue: string }
>('pos/createSale', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/pos/sale', payload);
    return data as PosSaleResult;
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.message ?? 'Erreur lors de la vente');
  }
});

const PosSlice = createSlice({
  name: 'pos',
  initialState,
  reducers: {
    clearMessages(state) {
      state.error          = null;
      state.successMessage = null;
    },
    clearLastSale(state) {
      state.lastSale = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPosSale.pending, (state) => {
        state.loading        = true;
        state.error          = null;
        state.successMessage = null;
      })
      .addCase(createPosSale.fulfilled, (state, action) => {
        state.loading        = false;
        state.lastSale       = action.payload;
        state.successMessage = `Vente ${action.payload.document.numero_doc} enregistrée.`;
      })
      .addCase(createPosSale.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload ?? 'Erreur lors de la vente';
      });
  },
});

export const { clearMessages, clearLastSale } = PosSlice.actions;
export default PosSlice.reducer;
